import { graphql } from 'services/api';
import { DataFormProps } from './index';
import { UPDATE_PAGE, CREATE_PAGE } from 'graphqlQueriesAndMutations/mutations';
import { PageProps } from 'types/PageProps';

interface RespEditPage {
	isSuccess: boolean;
	data: PageProps | null;
}

export async function editPage(
	dataForm: DataFormProps,
	pageSelected: PageProps,
	handleNotify: any
) {
	const resp: RespEditPage = { isSuccess: false, data: null };

	try {
		const { data } = await graphql.mutate({
			mutation: UPDATE_PAGE,
			variables: {
				updatePageInput: {
					header_type: dataForm.header_type,
					id: pageSelected.id,
					name: dataForm.name,
					show_tab_bar: dataForm.show_tab_bar,
					slug: pageSelected.slug,
					background_color: dataForm.background_color,
					secondary_color: dataForm.secondary_color,
					contrast_color: dataForm.contrast_color,
					start_date: dataForm.start_date?.trim() ? dataForm.start_date : null,
					end_date: dataForm.end_date?.trim() ? dataForm.end_date : null
				}
			}
		});
		handleNotify('Página salva com sucesso', 'success');
		resp.isSuccess = true;
		resp.data = data.updatePage;
	} catch (error: any) {
		console.error('Erro ao salvar página:', error);
		handleNotify(error?.message || 'Erro ao salvar página', 'error');
		resp.isSuccess = false;
		resp.data = null;
	}

	return resp;
}

export async function createPage(dataForm: DataFormProps, handleNotify: any) {
	const resp: RespEditPage = { isSuccess: false, data: null };

	try {
		const { data } = await graphql.mutate({
			mutation: CREATE_PAGE,
			variables: {
				createPageInput: {
					header_type: dataForm.header_type,
					name: dataForm.name,
					show_tab_bar: dataForm.show_tab_bar,
					background_color: dataForm.background_color,
					secondary_color: dataForm.secondary_color,
					contrast_color: dataForm.contrast_color,
					start_date: dataForm.start_date?.trim() ? dataForm.start_date : null,
					end_date: dataForm.end_date?.trim() ? dataForm.end_date : null
				}
			}
		});
		handleNotify('Página criada com sucesso', 'success');
		resp.isSuccess = true;
		resp.data = data.createPage || data.updatePage;
	} catch (error: any) {
		console.error('Erro ao criar página:', error);
		handleNotify(error?.message || 'Erro ao criar página', 'error');
		resp.isSuccess = false;
		resp.data = null;
	}

	return resp;
}
